export const FieldFocus = () => {
  const fieldGroups = [...document.querySelectorAll('.field-group--block')]
  for (let fieldGroup of fieldGroups) {
    const fieldInput = fieldGroup.querySelector('.field')

    fieldInput.addEventListener("focus", evt => {
      fieldGroup.classList.add("field-group--block-focus")

      if (!evt.target.value) {
        fieldGroup.classList.add("field-group--block-animated")
      }
    }, false)

    fieldInput.addEventListener("blur", evt => {
      fieldGroup.classList.remove("field-group--block-focus")

      if (!event.target.value) {
        fieldGroup.classList.remove("field-group--block-animated")
      }
    }, false)

    setTimeout( () => {
      if (fieldInput.value) {
        fieldGroup.classList.add("field-group--block-animated")
      }
    }, 0)


  }
}
